module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/darts-icon-15ee2003217055280ad8b7fac35f026e.png";